import styled from "styled-components";

export const Container = styled.span`
  position: relative;
  width: 50px;
  &:hover .tooltip-text {
    visibility: visible;
  }
`;

export const ContainerTooltip = styled.div<{backgroundColor?: string; textColor?: string}>`
  .tooltipStyle {
    z-index: 99999999;
    background-color: ${({backgroundColor}) => backgroundColor ?? "#637381" };
    color: ${({textColor}) => textColor ?? "#fff" };
    opacity: 1;
  }
`;